import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>
          GESVET – App para digitalizar el trabajo veterinario en campo
        </title>
        <meta
          name="description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:title"
          content="GESVET – App para digitalizar el trabajo veterinario en campo"
        />
        <meta
          property="og:description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/c5d5ed29-b3ec-4d24-824a-945896b13c65/a683aef5-7460-454d-aed7-588f9c14e5a7?org_if_sml=1&amp;force_format=original"
        />
        <link rel="canonical" href="https://www.gesvet.com.ar/" />
        <meta property="og:url" content="https://www.gesvet.com.ar/" />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-welcome">
        <div className="hero-video-wrapper">
          <video
            src="/videos/manga%20gesvet%20apaisado.mp4"
            loop="true"
            muted="true"
            poster="https://play.teleporthq.io/static/svg/videoposter.svg"
            autoPlay="true"
            playsInline="true"
            className="hero-video-bg"
          ></video>
          <video
            src="/videos/8187697-sd_640_360_25fps1.mp4"
            loop="true"
            muted="true"
            poster="https://play.teleporthq.io/static/svg/videoposter.svg"
            autoPlay="true"
            playsInline="true"
            className="home-thq-hero-video-bg-elm hero-video-bg"
          ></video>
          <div className="home-thq-hero-overlay-elm hero-overlay"></div>
        </div>
        <div className="hero-content-container">
          <div className="hero-text-block">
            <h1 className="home-hero-title hero-title">
              Aplicación para Veterinarios de Campo
            </h1>
            <p className="hero-subtitle">
              Digitalización inteligente para el veterinario de campo. Una
              aplicación creada por veterinarios para veterinarios, diseñada
              para optimizar la gestión ganadera en cualquier condición.
            </p>
            <div className="hero-cta-group">
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.exeo.gesvet"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="home-thq-btn-elm1 btn btn-primary btn-lg">
                    <span>Descargar App</span>
                  </div>
                </a>
              </div>
              <p className="home-thq-section-content-elm10 section-content">
                Gestiona establecimientos, servicios y estadísticas desde tu
                dispositivo móvil, incluso sin conexión.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="features-benefits">
        <div className="features-container">
          <div className="features-header">
            <h2 className="section-title">
              Beneficios y funcionalidades clave
            </h2>
            <p className="section-subtitle">
              Herramientas diseñadas para simplificar el trabajo del veterinario
              y llevar la gestión al siguiente nivel.
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Trabajo Offline</h3>
              <p className="section-content">
                Recolección de datos en la manga sin necesidad de conexión a
                internet, ideal para condiciones de campo extremas.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M13 17a4 4 0 1 0 8 0a4 4 0 1 0-8 0"></path>
                    <path d="M17 13v4h4M12 3v4a1 1 0 0 0 1 1h4"></path>
                    <path d="M11.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v2m0 3v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Informes Automáticos</h3>
              <p className="section-content">
                Generación instantánea de reportes en PDF y Excel para entregar
                al productor vía WhatsApp o Gmail.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m7 7l10 10l-5 5V2l5 5L7 17"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Lectura Electrónica</h3>
              <p className="section-content">
                Integración completa con bastones Bluetooth para la lectura
                rápida de caravanas electrónicas.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m17 18l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                    <path d="M17 22v-4h-4m7.996-2.749A4.5 4.5 0 0 0 17.495 8h-1.79a7 7 0 1 0-12.709 5.607"></path>
                    <path d="M7 10v4h4"></path>
                    <path d="m7 14l1.535-1.605a5 5 0 0 1 8 1.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Backup en la Nube</h3>
              <p className="section-content">
                Sistema de respaldo automático para asegurar que tu información
                esté siempre protegida y disponible.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 13a2 2 0 1 0 4 0a2 2 0 1 0-4 0m3.45-1.45L15.5 9.5"></path>
                    <path d="M6.4 20a9 9 0 1 1 11.2 0z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Estadísticas Anuales</h3>
              <p className="section-content">
                Seguimiento técnico ordenado por establecimiento con porcentajes
                de preñez e indicadores clave.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Gestión Ilimitada</h3>
              <p className="section-content">
                Administra todos tus establecimientos y servicios profesionales
                sin restricciones de volumen.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="app-showcase">
        <div className="app-showcase-container">
          <div className="app-showcase-header">
            <h2 className="section-title">Explora la App GESVET</h2>
            <p className="section-subtitle">
              Digitalización inteligente diseñada por y para veterinarios de
              campo.
            </p>
          </div>
          <div className="app-showcase-layout">
            <div className="phone-mockup-wrapper">
              <div className="phone-frame">
                <div className="phone-screen">
                  <div className="app-status-bar">
                    <span className="status-time">10:45</span>
                    <div className="status-icons">
                      <svg
                        fill="currentColor"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2"></path>
                      </svg>
                      <svg
                        fill="currentColor"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                      >
                        <path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4"></path>
                      </svg>
                    </div>
                  </div>
                  <div
                    id="view-dashboard"
                    className="home-thq-app-view-elm1 active app-view"
                  >
                    <img
                      alt="image"
                      src="/images/carrusel/dashboard-recortado-300w.jpeg"
                      className="home-thq-image-elm"
                    />
                  </div>
                  <div
                    id="view-establishments"
                    className="home-thq-app-view-elm2 app-view"
                  >
                    <img
                      alt="image"
                      src="/images/carrusel/establecimientos-recortado1-300w.jpeg"
                      className="home-image1"
                    />
                  </div>
                  <div
                    id="view-settings"
                    className="home-thq-app-view-elm3 app-view"
                  >
                    <img
                      alt="image"
                      src="/images/carrusel/servicios-recortado-300w.jpeg"
                      className="home-image2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="app-showcase-content">
              <div data-view="dashboard" className="feature-detail-card active">
                <div className="feature-icon-box">
                  <svg
                    fill="none"
                    width="28"
                    height="28"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M10 13a2 2 0 1 0 4 0a2 2 0 1 0-4 0m3.45-1.45L15.5 9.5"></path>
                    <path d="M6.4 20a9 9 0 1 1 11.2 0z"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Dashboard Inteligente</h3>
                <p className="section-content">
                  Visualiza el estado reproductivo de tus rodeos al instante.
                  Gráficos de preñez, tacto y estadísticas anuales para una toma
                  de decisiones basada en datos reales.
                </p>
                <ul className="feature-list">
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>
                      {' '}
                      Porcentajes de preñez automática
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>
                      {' '}
                      Filtros por establecimiento y año
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                </ul>
              </div>
              <div data-view="establishments" className="feature-detail-card">
                <div className="feature-icon-box">
                  <svg
                    fill="none"
                    width="28"
                    height="28"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                </div>
                <h3 className="section-subtitle">
                  Gestión de Establecimientos
                </h3>
                <p className="section-content">
                  Administra todos tus establecimientos sin límites. Organiza la
                  información por propietario y ubicación para un acceso rápido
                  en la manga.
                </p>
                <ul className="feature-list">
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>
                      {' '}
                      Reportes PDF y Excel al instante
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>
                      {' '}
                      Envío directo por WhatsApp
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                </ul>
              </div>
              <div data-view="settings" className="feature-detail-card">
                <div className="feature-icon-box">
                  <svg
                    fill="none"
                    width="28"
                    height="28"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </svg>
                </div>
                <h3 className="section-subtitle">Servicios</h3>
                <p className="section-content">
                  Administra todos tus servicios sin límites. Organiza la
                  información por tipo de práctica, fecha y categoría animal
                  para un registro ágil y preciso en la manga.
                </p>
                <ul className="feature-list">
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Tacto</span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Tacto Simple</span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Tacto Preservicio</span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Revisacion de Toros</span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>IATF</span>
                  </li>
                  <li>
                    <svg
                      fill="none"
                      width="16"
                      height="16"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="3"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>IATF Simple</span>
                  </li>
                </ul>
              </div>
              <div className="showcase-cta">
                <a
                  href="https://play.google.com/store/apps/details?id=com.exeo.gesvet"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-thq-btn-elm2 btn btn-primary btn-lg"
                >
                  Descargar App Gratuita
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container12">
        <div className="home-container13">
          <Script
            html={`<script>
      ;(function () {
        ;(function () {
          const navButtons = document.querySelectorAll(".nav-btn")
          const appViews = document.querySelectorAll(".app-view")
          const featureCards = document.querySelectorAll(".feature-detail-card")
          const phoneFrame = document.querySelector(".phone-frame")
          function switchView(targetId) {
            // Update Phone Views
            appViews.forEach((view) => {
              view.classList.remove("active")
              if (view.id === "view-" + targetId) {
                view.classList.add("active")
              }
            })
            // Update Nav Buttons
            navButtons.forEach((btn) => {
              btn.classList.remove("active")
              if (btn.getAttribute("data-target") === targetId) {
                btn.classList.add("active")
              }
            })
            // Update Content Cards
            featureCards.forEach((card) => {
              card.classList.remove("active")
              if (card.getAttribute("data-view") === targetId) {
                card.classList.add("active")
              }
            })
            // Suble tilt effect on view change
            if (phoneFrame) {
              phoneFrame.style.transform = "rotateY(5deg) scale(1.02)"
              setTimeout(() => {
                phoneFrame.style.transform = "rotateY(0deg) scale(1)"
              }, 300)
            }
          }
          navButtons.forEach((button) => {
            button.addEventListener("click", () => {
              const target = button.getAttribute("data-target")
              switchView(target)
            })
          })
          // Optional: Auto-rotation for desktop visibility
          let rotationInterval
          const views = ["dashboard", "establishments", "settings"]
          let currentIdx = 0
          function startAutoRotation() {
            rotationInterval = setInterval(() => {
              currentIdx = (currentIdx + 1) % views.length
              switchView(views[currentIdx])
            }, 5000)
          }
          function stopAutoRotation() {
            clearInterval(rotationInterval)
          }
          // Stop auto-rotation when user interacts
          navButtons.forEach((btn) => {
            btn.addEventListener("mousedown", stopAutoRotation)
          })
          featureCards.forEach((card) => {
            card.addEventListener("mousedown", stopAutoRotation)
            card.addEventListener("mouseenter", () => {
              const target = card.getAttribute("data-view")
              if (target) {
                switchView(target)
              }
            })
            card.addEventListener("click", () => {
              const target = card.getAttribute("data-view")
              if (target) {
                switchView(target)
              }
            })
          })
          // Start rotation on load
          startAutoRotation()
        })()
      })()
    </script>`}
          ></Script>
        </div>
      </div>
      <section className="stats-section">
        <div className="stats-container">
          <div className="stats-header">
            <h2 className="section-title">Impacto Real en el Campo</h2>
            <p className="section-subtitle">
              Digitalizamos la gestión veterinaria para transformar datos en
              decisiones estratégicas. Nuestra tecnología acompaña al
              profesional en cada paso del proceso productivo.
            </p>
          </div>
          <div className="stats-grid">
            <div className="home-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stat-svg"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </div>
              <div className="stat-content">
                <span id="stat-establishments" className="stat-number">
                  3.000+
                </span>
                <h3 className="home-stat-label">
                  Establecimientos Gestionados
                </h3>
                <p className="stat-description">
                  Datos organizados por campo para un control total de la
                  producción.
                </p>
              </div>
            </div>
            <div className="home-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stat-svg"
                >
                  <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m4 7h4m-4 5h4m-8-5h.01M8 16h.01"></path>
                </svg>
              </div>
              <div className="stat-content">
                <span id="stat-services" className="stat-number">
                  7.000+
                </span>
                <h3 className="home-stat-label">Servicios Realizados</h3>
                <p className="stat-description">
                  Tacto, IATF y Raspaje con seguimiento técnico preciso y
                  ordenado.
                </p>
              </div>
            </div>
            <div className="home-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stat-svg"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle r="4" cx="9" cy="7"></circle>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="stat-content">
                <span id="stat-animals" className="stat-number">
                  600.000+
                </span>
                <h3 className="home-stat-label">Animales Atendidos</h3>
                <p className="stat-description">
                  Registro individual y compatible con caravana electrónica en
                  tiempo real.
                </p>
              </div>
            </div>
            <div className="home-stat-card">
              <div className="stat-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stat-svg"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" x2="8" y1="13" y2="13"></line>
                  <line x1="16" x2="8" y1="17" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </div>
              <div className="stat-content">
                <span id="stat-reports" className="stat-number">
                  12.500+
                </span>
                <h3 className="home-stat-label">Informes Generados</h3>
                <p className="stat-description">
                  Reportes PDF y Excel automáticos enviados directamente al
                  productor.
                </p>
              </div>
            </div>
          </div>
          <div className="stats-footer">
            <p className="section-content">
              Nuestros datos permiten conocer porcentajes de preñez, animales
              rechazados y otros indicadores clave para mejorar la rentabilidad
              del establecimiento.
            </p>
          </div>
        </div>
      </section>
      <div className="home-container14">
        <div className="home-container15">
          <Script
            html={`<script>
(function(){
  // Simple counter animation logic
  const animateValue = (id, start, end, duration) => {
    const obj = document.getElementById(id)
    if (!obj) return

    // Clean the string to get just numbers for the calculation
    const isPlus = obj.innerText.includes("+")
    const target = parseInt(end.replace(/,/g, ""))
    const startValue = parseInt(start)

    let startTimestamp = null
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp
      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      const current = Math.floor(progress * (target - startValue) + startValue)

      // Format back with commas
      obj.innerText = current.toLocaleString() + (isPlus ? "+" : "")

      if (progress < 1) {
        window.requestAnimationFrame(step)
      }
    }
    window.requestAnimationFrame(step)
  }

  // Intersection Observer to trigger animation when section is visible
  const observerOptions = {
    threshold: 0.2,
  }

  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateValue("stat-establishments", "0", "3000", 2000)
        animateValue("stat-services", "0", "7600", 2000)
        animateValue("stat-animals", "0", "600000", 6000)
        animateValue("stat-reports", "0", "12500", 3000)
        statsObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)

  const statsSection = document.querySelector(".stats-section")
  if (statsSection) {
    statsObserver.observe(statsSection)
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section className="process-field">
        <div className="process-wrapper">
          <div className="process-intro">
            <h2 className="section-title">Cómo funciona en campo</h2>
            <p className="section-subtitle">
              Un flujo optimizado para la manga, incluso sin conexión.
            </p>
          </div>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-number">
                <span>01</span>
              </div>
              <h3 className="section-subtitle">Seleccionar Establecimiento</h3>
              <p className="section-content">
                Elige el lugar de trabajo de tu lista gestionada.
              </p>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>02</span>
              </div>
              <h3 className="section-subtitle">Cargar Servicio</h3>
              <p className="section-content">
                Define la tarea: Tacto, IATF o Revisación de Toros.
              </p>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>03</span>
              </div>
              <h3 className="section-subtitle">Leer Caravana</h3>
              <p className="section-content">
                Usa el bastón Bluetooth para una carga ultra rápida.
              </p>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>04</span>
              </div>
              <h3 className="section-subtitle">Generar Informe</h3>
              <p className="section-content">
                Exporta a PDF/Excel y envía al productor al instante.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="home-thq-testimonials-rail-elm testimonials-rail">
          <div className="testimonial-card">
            <div className="testimonial-rating">
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
            <p className="section-content">
              &quot;Excelente herramienta, simplifica la toma de datos y
              elaboración de informes. Los clientes quedan muy contentos
              mejorando el servicio profesional.&quot;
            </p>
            <div className="testimonial-author">
              <span className="author-name">Emilio Sequi - Olavarría</span>
              <span className="author-role">Veterinario</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
            <p className="section-content">
              &quot;App muy práctica. Permite generar un informe con datos
              básicos tomados en un trabajo de manga en bovinos de forma
              inmediata&quot;
            </p>
            <div className="testimonial-author">
              <span className="author-name">Ricardo Martiarena - Tandil</span>
              <span className="author-role">Veterinario</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
            <p className="section-content">
              &quot;Muy recomendable, rápida, práctica y fácil de usar&quot;
            </p>
            <div className="testimonial-author">
              <span className="author-name">Lucas Fernandez - Patagonia</span>
              <span className="author-role">Veterinario</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
            <p className="section-content">
              &quot;Práctica. intuitiva y ágil. Vet. Gastón Cuestas&quot;
            </p>
            <div className="testimonial-author">
              <span className="author-name">Cordoba</span>
              <span className="author-role">Veterinario</span>
            </div>
          </div>
        </div>
      </section>
      <section className="quick-links">
        <div className="links-container">
          <div className="links-header">
            <h2 className="section-title">Enlaces rápidos</h2>
            <p className="section-subtitle">
              Acciones frecuentes a un solo toque.
            </p>
          </div>
          <div className="links-grid">
            <div className="home-thq-link-card-elm1 link-card">
              <div className="link-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7v14"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="link-info">
                <h3 className="section-subtitle">Nuevo Servicio</h3>
                <p className="section-content">
                  Inicia una nueva carga de datos en campo.
                </p>
              </div>
            </div>
            <div className="home-thq-link-card-elm2 link-card">
              <div className="link-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4m4-5l5 5l5-5m-5 5V3"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="link-info">
                <h3 className="section-subtitle">Descargar Reporte</h3>
                <p className="section-content">
                  Genera el PDF/Excel del último trabajo.
                </p>
              </div>
            </div>
            <div className="link-card">
              <div className="link-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 12a9 9 0 0 0-9-9a9.75 9.75 0 0 0-6.74 2.74L3 8m0 0V4m0 4h4m-4 4a9 9 0 0 0 9 9a9.75 9.75 0 0 0 6.74-2.74L21 16m0 0v4m0-4h-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="link-info">
                <h3 className="section-subtitle">Sincronizar Backup</h3>
                <p className="section-content">
                  Asegura tus datos en la nube ahora.
                </p>
              </div>
            </div>
            <Link to="/bluetooth">
              <div className="home-thq-link-card-elm4 link-card">
                <div className="link-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m7 7l10 10l-5 5V2l5 5L7 17"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="link-info">
                  <h3 className="section-subtitle">Configurar Bluetooth</h3>
                  <p className="section-content">
                    Vincula tu bastón lector de caravanas.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>
      <div className="home-container16">
        <div className="home-container17">
          <Script
            html={`<style>
* {
  box-sizing: border-box;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container18">
        <div className="home-container19">
          <Script
            html={`<script defer data-name="gesvet-interactions">
(function(){
  // Modal Functionality
  const manualModal = document.getElementById("manualModal")
  const openManualBtn = document.getElementById("openManualBtn")
  const closeManualBtn = document.getElementById("closeManualBtn")

  if (openManualBtn && manualModal) {
    openManualBtn.addEventListener("click", () => {
      manualModal.showModal()
    })
  }

  if (closeManualBtn && manualModal) {
    closeManualBtn.addEventListener("click", () => {
      manualModal.close()
    })
  }

  // Close modal on backdrop click
  if (manualModal) {
    manualModal.addEventListener("click", (e) => {
      const dialogDimensions = manualModal.getBoundingClientRect()
      if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) {
        manualModal.close()
      }
    })
  }

  // Simple scroll animation for feature cards
  const featureCards = document.querySelectorAll(".feature-card")
  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  featureCards.forEach((card) => {
    card.style.opacity = "0"
    card.style.transform = "translateY(20px)"
    card.style.transition = "all 0.6s ease-out"
    observer.observe(card)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer
        text={
          <Fragment>
            <span className="home-text25">Soporte</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text26">Aplicacion</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="home-text27">Home</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="home-text28">Bluetooth</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="home-text29">Soporte1</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Home
